import React from "react";
import clsx from "clsx";
import "./chat-box-list-item.styles.scss";
import type { IUIMessageContent } from "../../shared/types";
import zCBLAnimationModule from "../../core/engines";
import { SnapEffectContainer } from "../../core/animations";

export interface ChatBoxListItemProps {
	layoutType?: "Left" | "Center" | "Right";
	spacing?: 0 | 4 | 8 | 16;
	className?: string;
	children?: React.ReactNode;
	content: IUIMessageContent;
}

const BlockName = "chat-box-list-item";
const ClassNames = {
	Block: BlockName,
	Modifiers: {
		Left: "--left",
		Center: "--center",
		Right: "--right",

		Spacing0: "--spacing-0",
		Spacing4: "--spacing-4",
		Spacing8: "--spacing-8",
		Spacing16: "--spacing-16",
	},
	Elements: {},
} as const;

export type ChatBoxListItemComponent = React.FC<ChatBoxListItemProps> & {
	ClassNames: typeof ClassNames;
};

export const ChatBoxListItem = ((props: ChatBoxListItemProps) => {
	return (
		<zCBLAnimationModule.Component.Flipped
			flipId={`cbl-i-${props.content.cliMsgId}`}
			scale={false}
			onExit={(element, index, removeElement, decisionData, animationNG) => {
				// debugger;
				SnapEffectContainer.EventListener.dispatchEvent("animate-snap", { element });
				removeElement();

				// 	debugger;
				// 	//TODO: Đợi để animation hoàn thành thì mới remove element.
				// 	let closureResolve: any = () => {};
				// 	new Promise((resolve, reject) => {
				// 		closureResolve = resolve;
				// 	}).then(removeElement);
				// 	// element.style.visibility = "hidden";
				// 	SnapEffectContainer.EventListener.dispatchEvent("animate-snap", {
				// 		element,
				// 		onComplete: closureResolve,
				// 	});
				// }}
			}}
		>
			<div
				className={clsx(
					ChatBoxListItem.ClassNames.Block,
					props.className,
					props.layoutType && ChatBoxListItem.ClassNames.Modifiers[props.layoutType],
					props.spacing != undefined &&
						ChatBoxListItem.ClassNames.Modifiers[`Spacing${props.spacing}`],
				)}
			>
				{props.children}
			</div>
		</zCBLAnimationModule.Component.Flipped>
	);
}) as ChatBoxListItemComponent;
ChatBoxListItem.ClassNames = ClassNames;
